import * as React from 'react';
import PricePresentation, { IPricePresentationBase } from '../PricePresentation';
import { IQuantityPrice } from '@vp/vp-js-token-engine';

export default class QtyForPrice extends React.Component<IPricePresentationBase<IQuantityPrice>> {
  public render(): JSX.Element {
    return (
      <PricePresentation
        type="qtyForPrice"
        pricingInfo={this.props.pricingInfo}
        placeHolderText={this.props.placeHolderText}
      />
    );
  }
}
